export default __webpack_public_path__ + "static/media/icon-doubt.73f604aa.svg";